import PropTypes from 'prop-types';

export const propTypes = {
	onRefresh: PropTypes.func,
	subtitle: PropTypes.string,
	title: PropTypes.string.isRequired,
};
